var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.module.mdiIcon)?_c('i',{staticClass:"mdi module-mdi",class:`mdi-${_vm.module.mdiIcon}`}):(_vm.module.icondata)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.legacy)}}):_c('i',{staticClass:"mdi module-mdi text-muted mdi-help-circle-outline"})
}
var staticRenderFns = []

export { render, staticRenderFns }